import Button from "components/Button";

export const EmptyTable = ({
  label,
  buttonLabel,
  href,
  buttonWidth = "160px",
}: {
  label: string;
  buttonLabel: string;
  href: string;
  buttonWidth?: string;
}) => {
  return (
    <div className=" flex flex-1 items-center justify-center bg-white pb-20">
      <div className="relative top-10 flex h-[118px] flex-col items-center justify-between">
        <p className="text-24px">{label}</p>
        <div className={`w-[${buttonWidth}]`}>
          <Button text={buttonLabel} href={href} />
        </div>
      </div>
    </div>
  );
};
